import { Getter, State, Action, Mutation } from 'vuex-class'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { localCurrency } from '@/plugins/currency';

@Component
export default class SkeletonFluid extends Vue {
  // @Prop({ default: '#ECEBEB' }) color!: String
  @Getter getCart: any
  @Getter getOpenCart: any
  @Mutation OPEN_CART: any
  @Getter getCountry: any

  get getProductsQty() {
    const cart = this.getCart;
    if(cart && cart.cart_products) {
      const cartProducts = cart.cart_products;
      if (cartProducts.length) {
        let qty = 0;
        cartProducts.map((item) => {
          qty = item.quantity_total + qty;
        })
        return qty;
      }
    }
    return 0;
  }

  get getProductsTotal() {
    const cart = this.getCart;
    if(cart && cart.total_decimal) {
      return localCurrency(cart.total_decimal);
    }
    return 0;
  }

  get hasDeliveryCost() {
    let response = true;
    const cart = this.getCart;
    if(cart && cart.total_delivery) {
      const deliveryText = cart.total_delivery;
      const deliveryValue = this.currencyParse(deliveryText);
      return !(deliveryValue === 0);
    }
    return response;
  }

  private currencyParse(value) {
    if (value.indexOf(".") !== -1) {
      value = value.split(".")[0];
      value = value.replace("$", "");
      value = value.replace(",", "");
      return parseFloat(value);
    }
    return value;
  }

  /* Modals */
  _toggleCard() {
    this.OPEN_CART(!this.getOpenCart)
  }
}

